import _ from "lodash";
export var componentIds = function componentIds() {
  var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var filters = ["status", "poliza_ramo", "coverage", "claim_date", "request_date", "claim_id", "company"];
  return _.without(filters, except);
};